<template>
    <div class="navMenu">
        <label v-for="(navMenu,index) in navMenus" :key="index">
            <!--只有一级菜单-->
            <el-menu-item
                v-if="navMenu&& navMenu.childList==null||!navMenu.childList.length"
                :key="navMenu.id"
                :data="navMenu"
                :index="navMenu.id"
            >
                <!--图标-->
                <i v-show="navMenu.icon" >
                    <img class="iconMenu" :src="navMenu.icon" />
                </i>
                <!--标题-->
                <!-- <span slot="title" >{{navMenu.name}}</span> -->
                <span slot="title">{{navMenu.name}}</span>
            </el-menu-item>
            <!--有多级菜单-->
            <el-submenu
                v-if="navMenu&& navMenu.childList&&navMenu.childList.length"
                :key="navMenu.id"
                :data="navMenu"
                :index="navMenu.id"
                style="background-color: #FFFFFF;"
            >
                <template slot="title">
                    <i v-show="navMenu.icon">
                        <img class="iconMenu" :src="navMenu.icon" />
                    </i>
                    <span v-show="!collapse" class="titleS">
                        {{navMenu.name}}
                    </span>

                    <!-- <span> {{navMenu.name}}</span> -->
                </template>
                <!--递归组件，把遍历的值传回子组件，完成递归调用-->
                <nav-menu :navMenus="navMenu.childList" class="second-menu"></nav-menu>
            </el-submenu>
        </label>
    </div>
</template>
 
<script>
export default {
    name: "navMenu", //使用递归组件必须要有
    props: ["navMenus", "collapse"], // 传入子组件的数据
    data() {
        return {
            iconUp:false,
        };
    },
    mounted() {},
    methods: {}
};
</script>
<style lang="less" scoped>
.navMenu {
    background-color: transparent;
    text-align: left;
}
.el-menu--vertical {
    left: 150px !important;
}
.iconMenu {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.second-menu .el-menu-item:hover {
    background-color: #e9f2fd;
}
.second-menu .el-menu-item {
    font-family: PingFangSC;
    font-weight: 400;
    font-size: 14px;
    padding-left: 55px !important;
    color: #3C6DAE;
    height: 40px;
    line-height: 39px;
}
.el-menu-item, .el-submenu__title{
    height: 40px;
    line-height: 40px;

    i,span{
        vertical-align: text-bottom;
    }
}
.el-menu-item.is-active {
    // border-left:5px solid #2EC1C4;
    // i{
    //     text-indent: -5px;
    // }
    // text-indent: -5px;
    background: transparent;
    color: #155BD4 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/comps/navMenu.vue